// src/mediator/TimeoutRegistry.js

// Dieses Modul exportiert ein sofort ausgeführtes Singleton-Objekt
// mit privatem Timeout-Speicher (via IIFE) und optionaler Mediator-Anbindung
// Vorteile: keine Konstruktion nötig, sofort nutzbar, leicht testbar

let globalMediator = null;

export const TimeoutRegistry = (() => {
    const store = new Map();

    /**
     * Plane einen benannten Timeout
     * @param {string} name - z.B. 'map:idle:fit'
     * @param {number} delay - Millisekunden
     * @param {function} callback - wird nach Ablauf ausgeführt
     */
    function schedule(name, delay, callback) {
        if (store.has(name)) {
            clearTimeout(store.get(name));
        }

        const id = setTimeout(() => {
            store.delete(name);
            callback();

            if (globalMediator) {
                globalMediator.publish('refactor:timeout:' + name, {
                    name,
                    triggeredAt: Date.now(),
                    display: new Date().toLocaleTimeString()
                });
            }
        }, delay);

        store.set(name, id);
    }

    /**
     * Stoppe einen laufenden Timeout
     * @param {string} name
     */
    function cancel(name) {
        if (store.has(name)) {
            clearTimeout(store.get(name));
            store.delete(name);
        }
    }

    /**
     * Prüfe, ob Timeout gerade aktiv ist
     * @param {string} name
     * @returns {boolean}
     */
    function isActive(name) {
        return store.has(name);
    }

    /**
     * Liste aller aktiven Timeout-Namen
     * @returns {string[]}
     */
    function list() {
        return Array.from(store.keys());
    }

    return { schedule, cancel, isActive, list };
})();

TimeoutRegistry.attachMediator = function(mediatorInstance) {
    globalMediator = mediatorInstance;
}